import React from 'react';
import { XCircle, AlertTriangle, Search, MousePointerClick, PhoneOff } from 'lucide-react';
import { motion } from 'framer-motion';
const painPoints = [{
  problem: 'Diseño desactualizado',
  cost: 'Cero confianza inicial',
  icon: Search
}, {
  problem: 'Template genérico',
  cost: 'Te ves amateur',
  icon: MousePointerClick
}, {
  problem: 'No apareces en Google',
  cost: 'Competencia gana',
  icon: PhoneOff
}];
export function ProblemSection() {
  return <section className="py-24 bg-dark relative overflow-hidden" data-id="element-353" data-mp="35h2fa0olyyjb">
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-red-900/10 via-dark to-dark pointer-events-none" data-id="element-354" data-mp="3jg1yutx9kn8m"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-355" data-mp="3ef5zmtnuxp9j">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-356" data-mp="1p2avud9fx1m5">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-357" data-mp="1k3zl80bbmn2v">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-358" data-mp="sbp2m96758ng">
              Haces Un Trabajo Increíble. <br data-id="element-359" data-mp="123lcehhnan7i" />
              <span className="text-red-500" data-id="element-360" data-mp="1244kz7lenz8v">
                Pero Tu Presencia Online Te Cuesta Clientes.
              </span>
            </h2>

            <div className="space-y-4 text-lg text-gray-400 border-l-2 border-red-500/30 pl-6" data-id="element-361" data-mp="170uzvrlh4osp">
              <p data-id="element-362" data-mp="1c2kbp9git6hu">
                Antes de llamarte, los clientes te buscan en Google. Juzgan tu
                profesionalismo en menos de{' '}
                <strong className="text-white" data-id="element-363" data-mp="3dtfcygthxxvy">7 segundos</strong>.
              </p>
              <p data-id="element-364" data-mp="3hur4wszuev7b">
                Y si lo que ven no refleja la calidad de tu trabajo,{' '}
                <strong className="text-red-400" data-id="element-365" data-mp="3hwk8u0j2n1bm">llaman a alguien más.</strong>
              </p>
              <p data-id="element-366" data-mp="p23m76e1t2j5">
                No porque trabajen mejor que tú. Sino porque se ven más
                profesionales online.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative rounded-3xl overflow-hidden border border-white/10 shadow-2xl" data-id="element-367" data-mp="xyuer8te5z8z">
            <img src="https://cdn.magicpatterns.com/uploads/2rQBgTvyhq8rw6xqUkqADG/aselite1.png" alt="Comparación de un website de contractor desactualizado versus uno profesional" className="w-full h-full object-cover" data-id="element-368" data-mp="1cpbg6s610p5v" />
            {/* Antes / Después labels */}
            <span className="absolute top-4 left-4 inline-flex items-center gap-1.5 bg-red-500/90 text-white text-xs font-bold uppercase tracking-wider px-3 py-1.5 rounded-full" data-id="element-369" data-mp="25dcu30zsivw1">
              <XCircle className="w-3.5 h-3.5" data-id="element-370" data-mp="1wc68wem74wwg" />
              Antes
            </span>
            <span className="absolute top-4 right-4 inline-flex items-center gap-1.5 bg-gold text-dark text-xs font-bold uppercase tracking-wider px-3 py-1.5 rounded-full" data-id="element-371" data-mp="20cyjpcapv9uu">
              Después
            </span>
          </motion.div>
        </div>

        {/* Pain points */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="mt-16 grid sm:grid-cols-3 gap-6" data-id="element-372" data-mp="1remt3a9uoc2e">
          {painPoints.map((point, index) => <div key={index} className="bg-dark-100 p-6 rounded-2xl border border-white/5 flex items-center gap-5 shadow-lg" data-id="element-373" data-mp="10lw5rm5q57ra" data-mpi={index}>
              <div className="bg-red-500/10 p-4 rounded-full shrink-0" data-id="element-374" data-mp="vomb9s3ha5wl">
                <point.icon className="w-7 h-7 text-red-500" data-id="element-375" data-mp="qtqgik6ux4fs" />
              </div>
              <div data-id="element-376" data-mp="mt6izfidfyt4">
                <h3 className="text-white font-bold mb-1" data-id="element-377" data-mp="mtpry6q1ncv0">{point.problem}</h3>
                <p className="text-gray-400 text-sm flex items-center gap-2" data-id="element-378" data-mp="hvo6xg9253gw">
                  <AlertTriangle className="w-4 h-4 text-gold shrink-0" data-id="element-379" data-mp="cvin2m914l9d" />
                  {point.cost}
                </p>
              </div>
            </div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="mt-24 text-center max-w-3xl mx-auto bg-gradient-to-b from-dark-100 to-dark p-10 rounded-3xl border border-gold/20 shadow-[0_0_40px_rgba(212,175,55,0.05)]" data-id="element-380" data-mp="3vlx8hawlgcq">
          <p className="text-gray-300 text-lg mb-4" data-id="element-381" data-mp="3pxm66p5l22d2">
            Un homeowner con un proyecto de $10,000 acaba de contratar a tu
            competencia.
          </p>
          <p className="text-white font-bold text-2xl mb-6" data-id="element-382" data-mp="2x7vt8jfot6ij">
            Porque su website se veía más confiable.
          </p>
          <p className="text-4xl font-extrabold text-gold" data-id="element-383" data-mp="32672ot22lf08">Eso termina hoy.</p>
        </motion.div>
      </div>
    </section>;
}